/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'chart': {
    width: 16,
    height: 16,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M1.589 4.589L5.3 8.3A4.989 4.989 0 0 0 5 10a5 5 0 0 0 5 5 4.989 4.989 0 0 0 1.7-.3l3.708 3.708A9.953 9.953 0 0 1 10 20 10 10 0 0 1 0 10a9.953 9.953 0 0 1 1.589-5.411zm3-3A9.953 9.953 0 0 1 10 0a10 10 0 0 1 10 10 9.953 9.953 0 0 1-1.589 5.411L14.7 11.7A4.989 4.989 0 0 0 15 10a5 5 0 0 0-5-5 4.989 4.989 0 0 0-1.7.3z" fill-rule="evenodd"/>'
  }
})
